<div id="region-container">
  <p-blockUI [blocked]="loading === true" />
  @if (!this._deviceService.isMobile()) {
    <div>
      @if (elements) {
        <div class="ui-g ui-fluid" id="region-action-buttons">
          <div class="buttons">
            @if (canCreate && !isMobileDevice()) {
              <div>
                <button
                  pButton
                  class="width-eighty"
                  label="{{ 'COMMON.LABEL.BUTTONS.NEW' | translate }}"
                  icon="fa fa-fw fa-plus-circle"
                  (click)="newRegion()"
                ></button>
              </div>
            }
            <button
              pButton
              class="refresh-button width-twenty"
              icon="fa fa-fw fa-refresh"
              (click)="refresh()"
            ></button>
            @if (!isMobileDevice()) {
              <div>
                <button
                  pButton
                  label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
                  icon="fa fa-fw fa-eraser"
                  (click)="clearTable()"
                ></button>
              </div>
            }
            <app-progress-spinner [enabled]="loading" />
          </div>
        </div>
      }
      <app-progress-spinner [enabled]="!elements" />
      <div [style.display]="!elements ? 'none' : ''">
        <app-general-grid
          [values]="elements"
          [columns]="columns"
          [loading]="loading"
          [rows]="rows"
          [totalRecords]="totalRecords"
          [filterable]="true"
          [screenName]="screenName"
          [lazy]="true"
          (lazyLoad)="lazyLoad($event)"
          [includeExportCSV]="false"
          (changeViewEvent)="changeViewEvent($event)"
          scrollHeight="calc(100vh - 256px)"
          [usePaginator]="true"
          [rowsPerPageOptions]="[50, 100, 200]"
          #grid
        />
      </div>
    </div>
  }

  @if (this._deviceService.isMobile()) {
    <p-panel
      [showHeader]="true"
      header="Filters"
      [toggleable]="true"
      [(collapsed)]="mobileFilterCollapsed"
    >
      <div class="ui-g ui-fluid">
        <div class="ui-g-12">
          <app-region-mobile-filter (mobileFilterEvent)="mobileFilter()" />
        </div>
      </div>
    </p-panel>
  }
  @if (this._deviceService.isMobile()) {
    <div>
      @if (elements) {
        <div class="ui-g ui-fluid" id="region-action-buttons">
          <app-progress-spinner [enabled]="!elements" />
          <div [style.display]="!elements ? 'none' : ''">
            <app-general-grid
              [values]="elements"
              [columns]="columns"
              [loading]="loading"
              [rows]="rows"
              [totalRecords]="totalRecords"
              [filterable]="true"
              [screenName]="screenName"
              [lazy]="true"
              (lazyLoad)="lazyLoad($event)"
              [includeExportCSV]="false"
              (changeViewEvent)="changeViewEvent($event)"
              scrollHeight="calc(100vh - 175px)"
              [usePaginator]="true"
              [rowsPerPageOptions]="[50, 100, 200]"
              #grid
            />
          </div>
        </div>
      }
    </div>
  }
</div>
